module.exports = "https://static.wmbcdn.com/uniweb/images/a3cfae9f74e7f66a109278c2371332d7.svg";